import styled from 'styled-components';

export const TitleWrapper = styled.div`
  background-color: #dfe3e6;
  max-width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const Title = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  min-width: 0;

  b {
    font-size: 20px;
    overflow-wrap: break-word;
    word-break: break-word;

    @media (max-width: 767px) {
      font-size: 16px;
    }
  }
`;

export const ListTitleWrapper = styled.span`
  font-weight: 400;
  font-size: 16px;
  display: block;
  margin-bottom: 4px;

  b {
    text-decoration: underline;
  }

  @media (max-width: 767px) {
    font-size: 14px;
  }
`;

export const ModalMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;

  small {
    display: block;
  }

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;
